import { useNavigate } from "react-router-dom";
import ManagerProfileNavData from "./ManagerProfileNavData.js";
// import { MdAccountCircle } from "react-icons/md";

const ManagerProfileNav = () => {
    const navigate = useNavigate();
    const mockManager = { managerName: "Naoyu", position: "Manager", managerID: "101" }

    return (
        <div className="manager-prof-nav">
            <div className="nav-wrapper">
                <img src="/images/naoyu-manager-photo.png" className="manager-icon"/>
            </div>
            <div className="user-name">
                {mockManager.managerName}
            </div>
            <div className="user-info">
                {mockManager.position}
            </div>
            <div className="user-info">
                {mockManager.managerID}
            </div>
            <ul className="nav_list">
                {ManagerProfileNavData.map((value, key) => {
                    return (
                        <li key={key} className="row"
                            onClick={() => navigate(value.link)}
                        >
                            <div className="title">{value.title}</div>
                        </li>
                    );
                })}
            </ul>
        </div >
    );
}

export default ManagerProfileNav;
